import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { mdiFileDocumentEditOutline } from "@mdi/js";

import { DffSideModule, DffUploadProgressOverlayModule, EmptyPageBadgeModule } from "@dffedb/ui";
import { SvgIconRegistry } from "@dffedb/util";
import { NoteModule } from "@e-forsyning/common/note";

import { FeatureNoterRoutingModule } from "./feature-noter-routing.module";
import { FeatureNoterComponent } from "./feature-noter.component";

@NgModule({
    imports: [CommonModule, DffSideModule, DffUploadProgressOverlayModule, EmptyPageBadgeModule, NoteModule, FeatureNoterRoutingModule],
    declarations: [FeatureNoterComponent]
})
export class EForsyningFeaturesNoterModule {
    constructor(svgIconRegistry: SvgIconRegistry) {
        svgIconRegistry.registerIcon(mdiFileDocumentEditOutline, "noter-page-empty");
    }
}
